import React, { useState, useEffect } from 'react';
import './PremiumMarketsForm.scss';
import GreenDot from '@/images/icons/GreenDot.svg';
import RedDot from '@/images/icons/RedDot.svg';
import { useTenantApi } from '@/hooks/useTenantApi';
import { ByzzerMask } from '@/components/ByzzerMask/ByzzerMask';

type PurchasedPremiumMarket = {
    sku: string;
    titl: string;
    type: string;
};

type PremiumMarketsTableData = {
    active: PurchasedPremiumMarket[];
    inactive: PurchasedPremiumMarket[];
};

const baseClassName = 'premium-markets-form';

export function PremiumMarketsForm() {
    const { getPremiumMarketsStatus, getPremiumMarketsRetailers } = useTenantApi();
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState<PremiumMarketsTableData>({ active: [], inactive: [] });
    const [premiumMarketsRetailers, setPremiumMarketsRetailers] = useState<string[]>([]);

    useEffect(() => {
        renderPremiumMarketsData();
    }, []);

    const renderPremiumMarketsData = async () => {
        setLoading(true);
        const approvalStatus = await getPremiumMarketsStatus();
        if (approvalStatus) {
            setTableData(approvalStatus);
        }
        const premiumMarketsRetailersList: string[] = await getPremiumMarketsRetailers();
        setPremiumMarketsRetailers(premiumMarketsRetailersList?.length ? premiumMarketsRetailersList : []);
        setLoading(false);
    };

    return (
        <div>
            <ByzzerMask loading={loading} />
            <div className={`${baseClassName}__section`}>
                <div className={`${baseClassName}__title`}>What are Premium Markets?</div>
                <div className={`${baseClassName}__subclass-subheader-content`}>
                    Premium Markets are markets in Byzzer that require an additional purchase to license. We love that
                    we’re able to give small and emerging brands expansive data without nickel-and-diming, and for that
                    reason, we only charge for Premium Markets when it’s required. These will typically be markets where
                    the Retailer collects revenue for each client who licenses their data, or that are sourced from
                    premium models such as our Amazon 1P and Costco data.
                    <br />
                    <br/>
                    For help purchasing a premium market, reach out to your NIQ Account Rep.
                </div>
            </div>
            <div className={`${baseClassName}__section`}>
                <div className={`${baseClassName}__title`}>Which Retailers are Premium?</div>
                <div className={`${baseClassName}__subclass-subheader-content`}>
                    In order to run reports or receive data for any of the below retailers, you will need to purchase
                    them.
                    <div className={`${baseClassName}__subclass-subheader-content-list`}>
                        <div className={`${baseClassName}__subclass-subheader-content-list-section`}>
                            {premiumMarketsRetailers?.map((retailer) => (
                                <div
                                    key={retailer}
                                    className={`${baseClassName}__subclass-subheader-content-list-item`}
                                >
                                    {retailer}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${baseClassName}__section`}>
                <div className={`${baseClassName}__title`}>Purchased Markets</div>
                <div className={`${baseClassName}__request-status-content`}>
                    See which markets have been purchased in your account. Reach out to your NIQ Account Rep with any
                    questions.
                </div>
                <table className={`${baseClassName}__request-status-table`}>
                    <tbody>
                        <tr>
                            <th>Retailer</th>
                            <th>Status</th>
                        </tr>
                        {tableData?.active?.length > 0 &&
                            tableData?.active.map((item: any, index) => (
                                <tr key={index}>
                                    {item.title ? (
                                        <>
                                            <td>{item.title}</td>
                                            <td>
                                                <span>
                                                    <img
                                                        className={`${baseClassName}__request-status-table-icon-status`}
                                                        src={GreenDot}
                                                        alt={''}
                                                    />
                                                    Purchased
                                                </span>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className={`${baseClassName}__request-status-table-null`}>--</td>
                                            <td className={`${baseClassName}__request-status-table-null`}>--</td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        {tableData?.inactive?.length > 0 &&
                            tableData?.inactive.map((item: any, index) => (
                                <tr key={index}>
                                    {item.title ? (
                                        <>
                                            <td>{item.title}</td>
                                            <td>
                                                <span>
                                                    <img
                                                        className={`${baseClassName}__request-status-table-icon-status`}
                                                        src={RedDot}
                                                        alt={''}
                                                    />
                                                    Expired
                                                </span>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td className={`${baseClassName}__request-status-table-null`}>--</td>
                                            <td className={`${baseClassName}__request-status-table-null`}>--</td>
                                        </>
                                    )}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default PremiumMarketsForm;
